import React, { useContext, useEffect, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import AuthContext from "../util/AuthContext";
import axios from "../api/axiosConfig";
import RecipeCard from "../components/RecipeCard";
import InitialRecipeLoader from "../components/loaders/InitialRecipeLoader";
import { useSearch } from "../util/SearchContext";

export default function RecipePage() {
  const { user } = useContext(AuthContext);
  const { id } = useParams();
  const location = useLocation();
  const { loadingHttpSearch } = useSearch();

  const [recipe, setRecipe] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("🔄 Checking if recipe exists in state...");

    // ✅ Get the passed recipe from navigation state
    const passedRecipe = location.state?.recipe;

    // ✅ If we already have the correct recipe, use it (skip API call)
    if (passedRecipe && passedRecipe.id === id) {
      console.log("✅ Using passed recipe:", passedRecipe.id, passedRecipe.title);
      setRecipe(passedRecipe);
      setLoading(false);
      return;
    }

    // ❌ No valid recipe? Fetch from API
    console.log("❌ No passed recipe. Fetching from API...");
    axios
      .get(`/api/recipe/${id}`, { withCredentials: true })
      .then((response) => {
        console.log("✅ API response:", response.data.id, response.data.title);
        setRecipe(response.data);
      })
      .catch((err) => {
        console.error("❌ API Error:", err);
        setError("Recipe not found or not accessible.");
      })
      .finally(() => setLoading(false));
  }, [id]); // ✅ Only runs when `id` changes

  // Back link routing  
  const backLink = location.state?.from || "/discover";

  return (
    <div className="px-2 sm:px-6 py-4 max-w-6xl mx-auto">
      {/* Back Link */}
      <div className="mb-2">
        <Link to={backLink} className="text-green-600 text-2xl hover:font-bold">
          ←
        </Link>
      </div>

      {/* Show loader while fetching */}
      {loading || loadingHttpSearch ? (
        <InitialRecipeLoader />
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <RecipeCard recipe={recipe} />
      )}
    </div>
  );
}
